import { createContext, useContext } from 'react';

import type { NonUndefined } from './types';

export const makeProviderWithHook = <TContext,>(name: string, getValue: () => TContext, defaultValue: TContext) => {
  const context = createContext<TContext>(defaultValue);
  context.displayName = name;

  const Provider = ({ children }: { children: React.ReactNode }) => (
    <context.Provider value={getValue()}>{children}</context.Provider>
  );

  const useHook = () => {
    const c = useContext(context);

    if (c === undefined) {
      throw new Error(`${name}.useHook must be used within a ${name}.Provider`);
    }

    return c as NonUndefined<TContext>;
  };

  return {
    Provider,
    useHook,
  };
};
